import { api } from ".."

// função para pesquisar os e-mails do financeiro
const FinancialEmailsService = async (search: string, page: number) => {

    const response = await api.get('financial_emails', {
        params: {
            search, page
        }
    });

    return response;

}
// função para pesquisar os e-mails do financeiro

// função para cadastrar um e-mail do financeiro
const FinancialEmailCreateService = async (name: string, email: string) => {

    const response = await api.post('financial_emails', {
        name, email
    });

    return response;

}
// função para cadastrar um e-mail do financeiro

// função para editar um e-mail do financeiro
const FinancialEmailUpdateService = async (id: number, name: string, email: string) => {

    const response = await api.put(`financial_emails/${id}`, {
        name, email
    });

    return response;

}
// função para editar um e-mail do financeiro

// função para desativar/ativar um e-mail do financeiro
const FinancialEmailDeleteService = async (id: number) => {

    const response = await api.delete(`financial_emails/${id}`);

    return response;

}
// função para desativar/ativar um e-mail do financeiro

export {
    FinancialEmailsService,
    FinancialEmailCreateService,
    FinancialEmailUpdateService,
    FinancialEmailDeleteService
}
